var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('apexchart',{key:_vm.chartComponentKey,attrs:{"type":"line","height":350,"weight":230,"options":_vm.chartRotationOptions,"series":_vm.chartTransactions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }